import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { currentLanguage } from '../current-language';
import { TranslationConfig } from './translations.model';

const initTranslations = (config: TranslationConfig) => {
  const resources: Resource = Object.entries(config.translations).reduce((acc, [language, values]) => {
    return {
      ...acc,
      [language]: {
        translation: values,
      },
    };
  }, {});
  i18n.use(initReactI18next).init({
    resources,
    lng: currentLanguage.get(),
    fallbackLng: config.defaultLanguage,

    interpolation: {
      escapeValue: false,
    },
  });

  currentLanguage.subscribe((language) => {
    i18n.changeLanguage(language);
  });
};

const addTranslation = (language: string, key: string, value: string) => {
  i18n.addResource(language, 'translation', key, value);
};

export { initTranslations, addTranslation };
